<script lang="ts">
  import type { Product } from "../../helpers/types";
  import { roundOf } from "../../helpers/priceCalculator";
  import InfoButton from "../molecules/InfoButton.svelte";
  import ComparePrices from "../molecules/ComparePrices.svelte";
  import format from "date-fns/format";
  import sv from "date-fns/locale/sv";
  import Text from "./Text.svelte";

  export let product: Product;
  export let defaultOpen: boolean = false;
  export let expandable: boolean = true;
  export let showPreviousMonthInfo: boolean = false;
  export let showComparePrice: boolean = true;

  $: costs = product.costs;
  const product_id = `product-specifiction-${product.id}`;
  $: discount = costs.discount != undefined;
  $: fixedWithTax = roundOf(costs.fixedCost * (costs.vat / 100 + 1), 1);
  $: kwhCost = roundOf(
    (costs.kwhCost - (costs.surcharge === undefined ? 0 : costs.surcharge)) * 100,
    1000
  );
  let viewSpecification = defaultOpen || !expandable;
</script>

<div
  id={product_id}
  aria-expanded={viewSpecification}
  class="transition-maxHeight mt-2 w-full xl:flex xl:space-x-2 xl:justify-between {viewSpecification
    ? ' max-h-96 duration-700'
    : 'max-h-0  duration-300'} overflow-hidden"
>
  <table class="text-left text-S overflow-hidden purchaseflow-specification-table">
    <thead>
      <tr>
        <th class="text-H7 font-bold pr-7">Specifikation</th>
        <th />
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="flex space-x-1 {viewSpecification ? 'absolute z-10' : ''}">
          <Text variant="primary">Elpris exkl moms</Text>
          {#if (product.type === "variable" || product.type === "hourly") && showPreviousMonthInfo}
            <InfoButton iconSize={15} class="text-Neutral700 z-10">
              Rörligt elpris och elcertifikatsavgift för {format(product.previousMonth, "MMMM", {
                locale: sv,
              })} månad
            </InfoButton>
          {/if}
        </td>
        <td>{kwhCost} öre/kWh</td>
      </tr>
      {#if costs.surcharge}
        <tr>
          <td>Påslag</td>
          <td>{roundOf(costs.surcharge * 100, 1000)} öre/kWh</td>
        </tr>
      {/if}
      {#if discount && costs.discount.kwhLength}
        <tr class="text-Red900">
          <td class="pl-3"> Rabatt {costs.discount.kwhLength * 10} mån </td>
          <td> {roundOf((costs.discount.kwhCost - costs.kwhCost) * 100)} öre/kWh </td>
        </tr>
        <tr>
          <td>Moms {costs.vat}%</td>
          <td> {roundOf(costs.discount.kwhVat * 100, 1000)} öre/kWh</td>
        </tr>
      {:else}
        <tr>
          <td>Moms {costs.vat}%</td>
          <td> {roundOf(costs.kwhVat * 100, 1000)} öre/kWh</td>
        </tr>
      {/if}
      <tr>
        <td class="pr-2 md:pr-8"> Månadsavgift inkl moms </td>
        <td> {fixedWithTax} kr/mån </td>
      </tr>
      {#if discount && costs.discount.fixedLength}
        <tr class="text-Red900">
          <td class="pl-3"> Rabatt {costs.discount.fixedLength * 10} mån </td>
          <td
            >{roundOf(costs.discount.fixedCost * (costs.vat / 100 + 1), 1) - fixedWithTax} kr/mån</td
          >
        </tr>
      {/if}
    </tbody>
  </table>
  {#if showComparePrice}
    <div class="mt-4 xl:mt-0">
      <span class="text-sm font-semibold">Jämförpris</span>
      <ComparePrices {product} />
    </div>
  {/if}
</div>
{#if expandable}
  <button
    type={"button"}
    aria-controls={product_id}
    class=" sm:-mb-3 text-left -mr-3 text-S self-end flex items-center text-Neutral700"
    onclick={() => (viewSpecification = !viewSpecification)}
  >
    <span class="flex-shrink-0 -ml-2 {viewSpecification ? 'minus' : 'plus'}" /><span class="mt-0.5"
      >Uppskattad kostnad. Se hur vi beräknat priset
    </span>
  </button>
{/if}
